import { useState, useCallback } from 'react';
import { areasAPI } from '../services/api';

/**
 * Herramientas de los tres catálogos (TBBC, AXD, Optimize) con el área a la
 * que pertenecen. La clave de cada herramienta es `${catalogo}:${id}` porque
 * los ids se repiten entre catálogos.
 */
export const useAreas = (showNotification) => {
  const [herramientas, setHerramientas] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadHerramientas = useCallback(async () => {
    setLoading(true);
    try {
      const res = await areasAPI.getHerramientas();
      setHerramientas(
        (res.data.herramientas || []).map((h) => ({
          ...h,
          costo: parseFloat(h.costo) || 0,
          pct_mesa: parseFloat(h.pct_mesa) || 50
        }))
      );
    } catch (error) {
      console.error('Error cargando herramientas:', error);
      showNotification?.('error', 'Áreas', 'No se pudieron cargar las herramientas');
    } finally {
      setLoading(false);
    }
  }, [showNotification]);

  // Aplica el área a una o varias herramientas (las de un grupo van juntas).
  // Actualización optimista; si falla se recarga desde el servidor. pctMesa es
  // opcional (sin él se conserva el porcentaje guardado).
  const setArea = useCallback(async (miembros, area, pctMesa, nombre) => {
    const keys = new Set(miembros.map((m) => `${m.catalogo}:${m.id}`));
    setHerramientas((list) =>
      list.map((h) =>
        keys.has(`${h.catalogo}:${h.id}`)
          ? { ...h, area, pct_mesa: pctMesa ?? h.pct_mesa }
          : h
      )
    );
    try {
      await Promise.all(
        miembros.map((m) => areasAPI.setArea(m.catalogo, m.id, area, pctMesa))
      );
      return true;
    } catch (error) {
      console.error('Error asignando área:', error);
      showNotification?.('error', 'Áreas', `No se pudo asignar "${nombre}"`);
      loadHerramientas();
      return false;
    }
  }, [showNotification, loadHerramientas]);

  return { herramientas, loading, loadHerramientas, setArea };
};
